import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Underline = styled.div`
  ${({ theme, displayStyles }) =>
    renderStyledElementStyles(theme, displayStyles.elements.underline)}
  ${({ theme, visualStyles }) =>
    renderStyledElementStyles(theme, visualStyles.elements.underline)}
`;
